import React from 'react';
import {
  Menu,
  Box,
  Typography,
  Button,
  Divider,
  Stack,
  FormControlLabel,
  Checkbox,
} from '@mui/material';

interface FilterOption {
  value: string;
  label: string;
}

interface FilterMenuProps {
  open: boolean;
  anchorEl: HTMLElement | null;
  selectedFilters: string[];
  filterOptions: FilterOption[];
  onClose: () => void;
  onFilterToggle: (filter: string) => void;
  onSelectAll: () => void;
  onDeselectAll: () => void;
}

export const FilterMenu: React.FC<FilterMenuProps> = ({
  open,
  anchorEl,
  selectedFilters,
  filterOptions,
  onClose,
  onFilterToggle,
  onSelectAll,
  onDeselectAll,
}) => {
  return (
    <Menu
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      PaperProps={{
        sx: { minWidth: 250 }
      }}
    >
      <Box sx={{ px: 2, py: 1 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
            Event Types
          </Typography>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button
              size="small"
              onClick={onSelectAll}
              sx={{ textTransform: 'none', minWidth: 'auto', px: 1, fontSize: '0.75rem' }}
            >
              All
            </Button>
            <Button
              size="small"
              onClick={onDeselectAll}
              sx={{ textTransform: 'none', minWidth: 'auto', px: 1, fontSize: '0.75rem' }}
            >
              None
            </Button>
          </Box>
        </Box>
        <Divider sx={{ mb: 1 }} />
        <Stack spacing={0.5}>
          {filterOptions.filter(opt => opt.value !== '').map(option => (
            <FormControlLabel
              key={option.value}
              control={
                <Checkbox
                  checked={selectedFilters.includes(option.value)}
                  onChange={() => onFilterToggle(option.value)}
                  size="small"
                  onClick={(e) => e.stopPropagation()}
                />
              }
              label={<Typography variant="body2">{option.label}</Typography>}
              onClick={(e) => e.stopPropagation()}
            />
          ))}
        </Stack>
      </Box>
    </Menu>
  );
};
